export function privatePreviewPath(artifactId: string, spaceId: string | null): string {
  const path = `/app/artifacts/${encodeURIComponent(artifactId)}/preview`;
  return spaceId ? `${path}?space=${encodeURIComponent(spaceId)}` : path;
}

/** Only this local route may be used as a preview's post-sign-in destination. */
export function isPrivatePreviewPath(path: string): boolean {
  return /^\/app\/artifacts\/[A-Za-z0-9_-]+\/preview(?:\?space=[A-Za-z0-9_-]+)?$/.test(path);
}
